import React, { useEffect, useState } from "react";
import Foodtag from "../common/Foodtag";
import { Link, useParams, useNavigate, useOutletContext } from "react-router-dom";
import { http } from "../../helpers/http";
import { useDispatch, useSelector } from "react-redux";
import {
  getCartData,
  getOutletLink,
  placeholderHandler,
} from "../../helpers/help";
import {
  updateFullScreenLoader,
  updateOnboardingState,
} from "../../redux/actions/authActions";
import { Rating } from "react-simple-star-rating";
import useCurrentPosition from "../../helpers/customHooks/useCurrentPosition";
import Auth from "../../auth/Auth";
import { toast } from "react-toastify";
import { WISHLIST } from "../../eums/messages";
import CardLoader from "../widgets/CardLoader";
// import { updateWishistCartCount } from "../../redux/actions/generalActions";
import {
  updateRestaurantList,
  updateRestaurantSearchKey,
} from "../../redux/actions/restaurantActions";
import Pagination from "../pagination/Pagination";
import NearOutlet from "../modals/NearOutlet";
import moment from "moment";

const Restaurant = (props) => {
  const [showCount, setShowCount] = useState(16)
  const navigate = useNavigate();
  const [openLogoutModal, setOpenLogoutModal] = useState({
    data: '',
    state: false
  });

  const { getLatLong } = useOutletContext();
  const [isLoading, setLoading] = useState(null);
  const dispatch = useDispatch();
  const { cuisineId } = useParams();
  const { active, setActive } = props;
  const { latitudeData, longitudeData, timezone } = useCurrentPosition();
  const restaurantList = useSelector((state) => state.restaurant.list);
  let searchKey = useSelector((state) => state.restaurant.searchKey);
  console.log(searchKey, "searchKey")
  const isDesktopMode = useSelector((state) => state?.general?.isDesktopMode);
  const [view, setView] = useState(false);
  const filterData = JSON.parse(sessionStorage.getItem("filterRestaurant"));
  const [page, setPage] = useState(1);

  const [newLoc, setNewLoc] = useState()


  const restaurant = () => {
    // let apiParams = new URLSearchParams();
    // apiParams.append("searchfoodtagandrestro", searchKey);
    // apiParams.append("page", page);
    // apiParams.append("size", 12);
    // apiParams = `?${apiParams.toString()}`;
    dispatch(updateFullScreenLoader(true));
    http(
      {
        method: "POST",
        url: `listRestaurant`,
        isSecure: true,
        body: {
          latitude: newLoc?.updatelatitudeData !== '' ? newLoc?.updatelatitudeData : latitudeData,
          longitude: newLoc?.updatelongitudeData !== '' ? newLoc?.updatelongitudeData : longitudeData,
          type: "Take Out",
          timezone: timezone,
          // ...filterData,
          // ...(cuisineId && { cuisineId: [cuisineId] }),
        },
      },
      (res) => {
        if (res.error === "false") {
          dispatch(updateRestaurantList(res));
          // setActive(!active)
        } else {
          dispatch(updateRestaurantList({}));
        }
        dispatch(updateFullScreenLoader(false));
      }
    );
  };


  const searchRest = () => {
    dispatch(updateFullScreenLoader(true));
    http(
      {
        method: "POST",
        url: `searchRestaurants`,
        isSecure: true,
        body: {
          latitude: latitudeData,
          longitude: longitudeData,
          type: "Take Out",
          timezone: timezone,
          restaurantName: searchKey
        }
      },
      (res) => {
        if (res.error === "false") {
          dispatch(updateRestaurantList(res));
        }
        else {
          dispatch(updateRestaurantList({}));
        }
        dispatch(updateFullScreenLoader(false));

      }
    );
  }
  // const searchRest = () => {
  //   dispatch(updateFullScreenLoader(true));

  //   // Check if there's a search key
  //   if (searchKey) {
  //     // If there's a search key, search for restaurants with the specified name
  //     http(
  //       {
  //         method: "POST",
  //         url: `searchRestaurants`,
  //         isSecure: true,
  //         body: {
  //           latitude: latitudeData,
  //           longitude: longitudeData,
  //           type: "Take Out",
  //           timezone: timezone,
  //           restaurantName: searchKey
  //         }
  //       },
  //       (res) => {
  //         if (res.error === "false") {
  //           dispatch(updateRestaurantList(res));
  //         } else {
  //           dispatch(updateRestaurantList({}));
  //         }
  //         dispatch(updateFullScreenLoader(false));
  //       }
  //     );
  //   } else {
  //     // If search key is empty, fetch all restaurants
  //     restaurant();
  //   }
  // }

  // useEffect(() => {
  //   if (latitudeData && longitudeData) {
  //     restaurant()
  //   }
  // }, [latitudeData, longitudeData]);


  useEffect(() => {
    if ((latitudeData && longitudeData)) {
      restaurant();
    }
  }, [latitudeData, longitudeData]);

  useEffect(() => {
    if (latitudeData && longitudeData) {
      searchKey && searchRest()
    }

  }, [latitudeData, longitudeData, searchKey])


  useEffect(() => {
    !isDesktopMode && getCartData();
    dispatch(updateRestaurantSearchKey(""));
  }, []);
  useEffect(() => {
    searchKey = {}
  }, []);

  // useEffect(() => {
  //   if (latitudeData && longitudeData) {
  //     // restaurant()
  //     searchRest();
  //   }
  // }, [])

  // useEffect(() => {
  //   if (latitudeData && longitudeData) {
  //     !searchKey && restaurant()

  //   }
  // }, [])


  // useEffect(() => {
  //   if (latitudeData && longitudeData) {
  //     restaurant();
  //   }
  // }, [latitudeData, longitudeData, page, searchKey]);

  // const handleFavourite = (data, index) => {
  //   if (!Auth.isUserAuthenticated()) {
  //     dispatch(updateOnboardingState("login"));
  //     return;
  //   }
  //   const newStatus = data.is_like ? 0 : 1;
  //   setLoading(data.outlet[0].outletId);
  //   http(
  //     {
  //       method: "POST",
  //       url: `addOutletToUserFavourite`,
  //       isSecure: true,
  //       body: {
  //         outletId: data.outlet[0].outletId,
  //         status: newStatus,
  //       },
  //     },
  //     (res) => {
  //       if (res.error === "false") {
  //         toast.success(data.is_like ? WISHLIST.DISLIKE : WISHLIST.LIKE);
  //         restaurantList.listRestaurants[index].is_like = newStatus;
  //         dispatch(updateRestaurantList({ ...restaurantList }));
  //         dispatch(updateWishistCartCount());
  //         setLoading(false);
  //       }
  //     }
  //   );
  // };


  const handleShowMore = () => {
    setShowCount(showCount + 16)
  }
  const handleShowless = () => {
    setShowCount(showCount - 16)
  }


  useEffect(() => {
    if (getLatLong) {
      setNewLoc(JSON.parse(sessionStorage.getItem('newLocation')));
    }
  }, [getLatLong])

  useEffect(() => {
    if (!searchKey) {
      restaurant()
    }
  }, [searchKey])
  return (
    <>
      <section className="restaurantsNear">
        <div className="cus_container">
          <div className="d-md-flex mobileview_TFDC">
            {/* filter box */}
            {/* <Foodtag /> */}
            {/* filter box end */}
            <div className="restaurant_view_all">
              <Link to="/" className="arrow_back d-inline">
                <span>
                  {" "}
                  <img src="./assets/img/arrowBack.svg" alt="arrow back" />
                </span>
                <span> Back</span>
              </Link>
              <div className="d-flex justify-content-between align-items-md-center mt-4 mb-5 flex-column flex-md-row">
                <div className="col_left">
                  <h4 className="head4 mb-0">Restaurants Near By</h4>
                </div>
                <div className="col-right d-flex align-items-center mt-md-0 mt-3 ms-auto">
                  <form>
                    <div className="inputGroup text-center me-sm-3 me-2">
                      <input
                        type="text"
                        className="input_control input-inside-img bg-white "
                        placeholder="Search Restaurant..."
                        value={searchKey}
                        onChange={(e) =>
                          dispatch(updateRestaurantSearchKey(e.target.value))
                        }
                      />
                    </div>
                  </form>
                  <div className="custab_btn d-sm-flex d-none ">
                    <button
                      onClick={() => setView(false)}
                      className={`${view === false ? "active" : ""} tabbtn`}
                    >
                      <img
                        src="./assets/img/unGrid_white.svg"
                        alt="arrow back"
                        className="Active_grout-item"
                      />
                      <img
                        src="./assets/img/unGrid.svg"
                        alt="arrow back"
                        className="deActive_grout-item"
                      />
                    </button>
                    <button
                      onClick={() => setView(true)}
                      className={`${view ? "active" : ""} tabbtn`}
                    >
                      <img
                        src="./assets/img/grid_item_img.svg"
                        alt="grid active"
                        className="Active_grout-item"
                      />
                      <img
                        src="./assets/img/grid_item_img_black.svg"
                        alt="grid deactive"
                        className="deActive_grout-item"
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div className="view_data_resaurant">
                {!restaurantList?.listRestaurants && (
                  <p className="nodata_found">No restaurants available for this location</p>
                )}
                {view === false ? (
                  <div className="grid_item_single">
                    <div className="restaurants_container">
                      <div className="restaurants_group">
                        {
                          restaurantList.listRestaurants && restaurantList.listRestaurants?.slice(0, showCount).map((item, index) => {
                            return (
                              <div
                                key={item.restaurantId}
                                className="res-box restaurants_item pointer"
                                onClick={() => {
                                  if (item.outlet.length > 1) {
                                    setOpenLogoutModal({
                                      state: true,
                                      data: item
                                    })
                                  } else {
                                    navigate(`/restaurant-details/${item.outlet[0].outletId}/menu`)
                                  }
                                }}
                              >
                                {isLoading === item.outlet[0].outletId && <CardLoader />}
                                <div

                                  // to={getOutletLink(item.outlet[0])} 
                                  className="">
                                  <div className="res_img position-relative resimg_fix">
                                    <img
                                      onError={placeholderHandler}
                                      src={item.restaurantImage}
                                      alt="restaurant"
                                      className="restaurant-img"
                                    />
                                    {item?.emergency_close === 0 ? (
                                      <div className="btn_res open">Open</div>
                                    ) : (
                                      <div className="btn_res close">Close</div>
                                    )}
                                  </div>


                                </div>
                                <div className="ms-sm-3">
                                  <div className="res_content">
                                    <div className="my-2 d-flex align-items-center justify-content-between">
                                      <h6 className="head6 text-break">{item.restaurantName}</h6>
                                    </div>
                                    <div className="ratting_sec d-flex align-items-center">

                                      <img
                                        src="./assets/img/star.svg"
                                      />
                                      <div className="review_start ms-2">

                                        <span>{item.averageReview}</span>


                                      </div>


                                      {/* <div className="review_start">
                            <Rating
                              initialValue={item.averageReview}
                              readonly
                            />
                          </div> */}
                                    </div>

                                  </div>
                                  <div>
                                    {/* <div
                                      // onClick={() =>
                                      //   setOpenLogoutModal({
                                      //     state: true,
                                      //     data: item
                                      //   })
                                      // }
                                      className="my-2 redC"
                                    >{item.outlet.length} outlets near you</div> */}
                                    {
                                      item.outlet?.length > 1 ? (
                                        <div
                                          className="my-2 redC"
                                        >
                                          {item.outlet.length} outlets near you

                                        </div>
                                      ) : (
                                        <div
                                          className="my-2 redC visHid"
                                        >
                                          {item.outlet.length} outlets near you

                                        </div>
                                      )
                                    }

                                  </div>
                                  <div className="d-flex align-items-center fz14">
                                    <div className="mintB me-2">{item.outlet[0].displayTime}
                                    </div>
                                    <span className="timeshow">


                                      {moment(item.outlet[0].business_hours.from_time, "h:mm a").format("h:mm A")} -{" "}
                                      {moment(item.outlet[0].business_hours.to_time, "h:mm a").format("h:mm A")}


                                    </span> <span
                                      className="ratingView d-flex align-items-center">

                                    </span>
                                  </div>
                                </div>

                                {/* <div className="">
                          <p>{item.displayTime}</p>
                          {
                            item.outlet.map((hours) => {
                              return (
                                <span>{hours?.business_hours.from_time}</span>
                              )
                            })
                          }

                        </div> */}


                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="grid_item_multiple">
                    <div className="restaurants_group">
                      {/* {restaurantList.listRestaurants &&
                        restaurantList.listRestaurants.map((item, index) => {
                          return (
                            <div
                              key={item.restaurantId}
                              className="res-box restaurants_item"
                            >
                              {isLoading === item.outlet[0].outletId && (
                                <CardLoader />
                              )}
                              <Link
                                key={index}
                                state={{ item }}
                                className="restaurants_item_in"
                                to={getOutletLink(item.outlet[0])}
                              >
                                <div className="res_img">
                                  <img
                                    onError={placeholderHandler}
                                    src={item.restaurantImage}
                                    alt="restaurant"
                                    className="restaurant-img"
                                  />
                                </div>
                                <div className="res_content">
                                  <div className="my-2 d-flex align-items-center justify-content-between">
                                    <h6 className="head6">
                                      {item.restaurantName}
                                    </h6>
                                    <div className="btn_res open">Open</div>
                                  </div>
                                  <p className="txt my-2">
                                    {item.outlet.map((food) => {
                                      return (food?.foodTag || []).map((tag, index) => {
                                        return (
                                          <span
                                            className="me-2"
                                            key={"tag" + index}
                                          >
                                            {tag.itemName},
                                          </span>
                                        );
                                      });
                                    })}
                                  </p> 
                                  <div className="ratting_sec d-flex align-items-center justify-content-between">
                                    <div className="review_start">
                                      <Rating
                                        initialValue={item.averageReview}
                                        readonly
                                      />
                                    </div>
                                     <div className="heart-img">
                                      <img
                                        src="./assets/img/wishlist-heart-icon-0.svg"
                                        alt="grat heart"
                                      />
                                    </div> 
                                  </div>
                                </div>
                              </Link>
                              <div
                                className="heart-img pointer"
                                style={{ bottom: "17px" }}
                                onClick={() => handleFavourite(item, index)}
                              >
                                <img
                                  src={`./assets/img/wishlist-heart-icon-${item.is_like}.svg`}
                                  alt="grat heart"
                                />
                              </div>
                            </div>
                          );
                        })} */}
                      {
                        restaurantList.listRestaurants && restaurantList.listRestaurants?.slice(0, showCount).map((item, index) => {
                          return (
                            <div
                              key={item.restaurantId}
                              className="res-box restaurants_item pointer"
                            >
                              {isLoading === item.outlet[0].outletId && <CardLoader />}
                              <div
                                onClick={() => {
                                  if (item.outlet.length > 1) {
                                    setOpenLogoutModal({
                                      state: true,
                                      data: item
                                    })
                                  } else {
                                    navigate(`/restaurant-details/${item.outlet[0].outletId}`)
                                  }
                                }}

                                // to={getOutletLink(item.outlet[0])}

                                className="">
                                <div className="res_img position-relative">
                                  <img
                                    onError={placeholderHandler}
                                    src={item.restaurantImage}
                                    alt="restaurant"
                                    className="restaurant-img"
                                  />
                                  {item?.emergency_close === 0 ? (
                                    <div className="btn_res open">Open</div>
                                  ) : (
                                    <div className="btn_res close">Closed</div>
                                  )}
                                </div>
                                <div className="res_content">
                                  <div className="my-2 d-flex align-items-center justify-content-between">
                                    <h6 className="head6 text-break">{item.restaurantName}</h6>
                                  </div>
                                  <div className="ratting_sec d-flex align-items-center">

                                    <img
                                      src="./assets/img/star.svg"
                                    />
                                    <div className="review_start ms-2">

                                      <span>{item.averageReview}</span>


                                    </div>


                                    {/* <div className="review_start">
                            <Rating
                              initialValue={item.averageReview}
                              readonly
                            />
                          </div> */}
                                  </div>

                                </div>
                                {
                                  item.outlet?.length > 1 ? (
                                    <div
                                      className="my-2 redC"
                                    >
                                      {item.outlet.length} outlets near you

                                    </div>
                                  ) : (
                                    <div
                                      className="my-2 redC visHid"
                                    >
                                      {item.outlet.length} outlets near you

                                    </div>
                                  )
                                }
                                <div className="d-flex align-items-center fz14">
                                  <div className="mintB   me-2">{item.outlet[0].displayTime}
                                  </div>
                                  <span className="timeshow">

                                    {moment(item.outlet[0].business_hours.from_time, "h:mm a").format("h:mm A")} -{" "}
                                    {moment(item.outlet[0].business_hours.to_time, "h:mm a").format("h:mm A")}


                                  </span> <span
                                    className="ratingView d-flex align-items-center">

                                  </span>
                                </div>
                              </div>
                              <div>
                                {/* <div
                                  // onClick={() =>
                                  //   setOpenLogoutModal({
                                  //     state: true,
                                  //     data: item
                                  //   })
                                  // }
                                  className="my-2 redC"
                                >{item.outlet.length} outlets near you</div> */}


                              </div>

                              {/* <div className="">
                          <p>{item.displayTime}</p>
                          {
                            item.outlet.map((hours) => {
                              return (
                                <span>{hours?.business_hours.from_time}</span>
                              )
                            })
                          }

                        </div> */}


                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                )}
              </div>
              <div className="mt-3">
                {/* {restaurantList.total_pages > 1 && (
                  <Pagination
                    totalPages={restaurantList?.total_pages}
                    currentPage={page}
                    page={page}
                    setPage={(page) => setPage(page)}
                  />
                )} */}
                {/* {restaurantList.listRestaurants &&
                  restaurantList.listRestaurants?.length > 0 && (
                    <div className="text-center middle-line-RL mt-md-5 mt-4">
                      <Link
                        to="/restaurants"
                        className="cusbtn btnsize17 d-block m-auto"
                      >
                        View More
                      </Link>
                    </div>
                  )} */}
                <div className="text-center middle-line-RL mt-md-5 mt-4">
                  {showCount < restaurantList.listRestaurants?.length ? (

                    <button className="cusbtn btnsize17 d-block m-auto bttranp" onClick={handleShowMore}> View More </button>
                  ) : (
                    <button className="cusbtn btnsize17 d-block m-auto bttranp" onClick={handleShowless}>View Less</button>
                  )}
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
      <NearOutlet
        openLogoutModal={openLogoutModal?.state}
        data={openLogoutModal?.data}
        setOpenLogoutModal={setOpenLogoutModal}
      />
    </>
  );
};

export default Restaurant;
